const NotificationActionTypes = {
  SET_HUB_CONNECTION: 'SET_HUB_CONNECTION',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
};

export default NotificationActionTypes;
